import axiosInstance from '@/services/axiosInstance'

async function getSEPAAccountsByCompany (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return null
  } else {
    const req = {
      url: 'api/SEPA/getSEPAAccounts',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getSEPAAccountsByCompany }
